import * as React from "react";
import styled, { css } from "styled-components";
import { left } from "../../../utils/rtl";
import defaultTheme from "../../../defaultTheme";
const StyledButtonPrimitiveContentChildren = styled.div.withConfig({
  displayName: "ButtonPrimitiveContentChildren__StyledButtonPrimitiveContentChildren",
  componentId: "sc-1m4y8u8-0"
})(["", ""], ({
  hasIcon,
  contentWidth
}) => css(["display:inline-block;width:", ";text-align:", ";"], contentWidth, hasIcon && left)); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198

StyledButtonPrimitiveContentChildren.defaultProps = {
  theme: defaultTheme
};

const ButtonPrimitiveContentChildren = ({
  children,
  hasIcon,
  contentWidth
}) => /*#__PURE__*/React.createElement(StyledButtonPrimitiveContentChildren, {
  hasIcon: hasIcon,
  contentWidth: contentWidth
}, children);

export default ButtonPrimitiveContentChildren;